export default __webpack_public_path__ + "static/media/screen2.b38d23af.png";